import React, { useState, useEffect, useRef } from 'react'

import {
    Button,
    Card, Collapse, Grid, Paper, Typography, Select,
    FormHelperText
} from "@material-ui/core";

import useStyles from "./styles";

import { InputBaseField, SelectField } from "../../components/InputField/InputField";
import { CustomBtn, Label } from "../../components/UiElements/UiElements";
import profilePlaceholder from '../../assets/img/profilePlaceholder.jpg';
import Envelope from '../../assets/img/icons/envelope-Bold.svg';
import Location from '../../assets/img/icons/map-marker-Bold.svg';
import { GetUserInfo } from "../../Services/GetUserInfo";
import { PostDataAPI } from '../../Services/APIService';
import EditPen from '../../assets/img/icons/pen-Regular.svg';
import Loader from './../../components/Loader/Loader';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import { withSnackbar } from "./../../components/Message/Alert";
import {
    formateMdnNumber,
    validatePhoneNumber,
    handleNumberKeyPress,
    allowedAttachments,
    validateEmail
} from '../../../src/components/Common/Extensions';

function Profile({ ...props }) {

    const classes = useStyles();
    const { showMessage } = props;
    const commonAttachments = allowedAttachments();
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [userID] = useState(user_info.user.userId);
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [associateId] = useState(user_info.user.associateId);
    const [userType] = useState(user_info.user.userType);
    const [state, setState] = React.useState({});
    const [customerRecord, setCustomerRecord] = React.useState({});
    const [errorMessages, setErrorMessages] = useState({});

    const [profileImage, setProfileImage] = useState({ file: null, fileToSend: null, fileName: null });

    const convertBytesToMegabytes = (bytes) => {
        return (bytes / (1024 * 1024)).toFixed(2);
    };

    function uploadSingleFile(e) {

        const file = e.target.files[0];
        if (file == null || file <= 0)
            return;
        const fileSize = convertBytesToMegabytes(file.size);
        if (fileSize > 10) {
            showMessage("Error", "File size must be less than 10 MB", "error", 3000);
            return;
        }
        const name = file.name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setProfileImage({
            file: URL.createObjectURL(file),
            fileToSend: file,
            fileName: file.name
        })
        updateCustomerProfileImage(URL.createObjectURL(file), file, file.name);
    }

    const inputFile = useRef(null);

    const uploadFile = () => {

        inputFile.current.click();
    };

    const genderOption = [
        {
            label: "Male",
            value: "Male",
        },
        {
            label: "Female",
            value: "Female",
        },

    ]

    const [lstCCType] = useState([
        { label: 'Please Select State', value: '' },
        { label: 'Mastercard', value: '2' },
        { label: 'Visa', value: '3' },
        { label: 'Amex', value: '4' },
        { label: 'Discover', value: '5' },

    ]);

    const [lstStates] = useState([
        { label: 'Please Select State', value: '' },
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'District of Columbia', value: 'DC' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho	', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'Va.WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' }
    ]);

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {
                    if (name == 'workPhone') {
                        setErrorMessages(prevState => ({
                            ...prevState,
                            errorWorkPhone: true
                        }));
                    }
                    else {
                        setErrorMessages(prevState => ({
                            ...prevState,
                            errorWorkPhone: true
                        }));
                    }

                }

            }
        }
        else
            e.preventDefault();
    }

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (name == 'password') {
            setState(prevState => ({
                ...prevState,
                confirmPassword: ''
            }));
        }
    }

    const handleCardChange = (event) => {
        let value = event.target.value.replace(/\D/g, ''); // remove non-numeric characters
        const { name } = event.target;

        if (value.length <= 16) {
            value = value.match(/.{1,4}/g)?.join('-') || ''; // add - space after every 4 digits
        } else {
            value = state.creditCardNumber; // ignore input if it exceeds 16 digits
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const ValidateRecord = (errorList) => {
        if (!state.fullName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFullName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFullName: false
            }));
        }

        if (!state.workPhone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorWorkPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorWorkPhone: false
            }));
        }
        if (!state.password) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPassword: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPassword: false
            }));
        }
        if (state.password.length < 8) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPasswordLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPasswordLength: false
            }));
        }
        if (state.password != state.confirmPassword) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorConfirmPassword: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorConfirmPassword: false
            }));
        }
        if (userType !== 'customer_user') {
            if (!state.lastName) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorlastName: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorlastName: false
                }));
            }           
        }
        if (userType === 'customer_user') {

            if (!state.email || !validateEmail(state.email)) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorEmail: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorEmail: false
                }));
            }

            if (!state.homeContactName) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeName: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeName: false
                }));
            }

            if (!state.homePhone || (state.homePhone && !validatePhoneNumber(state.homePhone))) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomePhone: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomePhone: false
                }));
            }

            if (!state.homeAddress1) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeAddress1: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeAddress1: false
                }));
            }

            //if (!state.homeAddress2) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorHomeAddress2: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorHomeAddress2: false
            //    }));
            //}

            if (!state.homeCity) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeCity: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeCity: false
                }));
            }

            if (!state.homeState) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeState: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeState: false
                }));
            }

            if (!state.homeZip) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeZip: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorHomeZip: false
                }));
            }
        }

    }

    const validateCreditCardExpiry = () => {
        if (!state.ccExpMonth || !state.ccExpYear || isNaN(state.ccExpMonth) || isNaN(state.ccExpYear))
            return false;
        if (state.ccExpMonth < 1 || state.ccExpMonth > 12)
            return false;
        if (state.ccExpYear < new Date().getFullYear().toString().substring(2))
            return false;

        return true;

    }

    const updateCustomerProfileImage = (_url, _file, _name) => {
        let method = "telispire/updateCustomerProfileImage";
        const formData = new FormData();
        formData.append("customerId", userID);
        formData.append("AssociateId", associateId)
        formData.append("UserType", userType);
        formData.append("formFile", _file);
        formData.append("fileName", _name);
        formData.append("accountPhoneNumber", state.accountPhoneNumber);

        PostDataAPI(method, formData, true, "formData").then((result) => {
            debugger;
            if (result.success == true) {

                if (result.data != null) {
                    user_info.user.userPhotoPath = result.data;
                    sessionStorage.removeItem('user_info')
                    sessionStorage.setItem('user_info', JSON.stringify(user_info))
                }
                showMessage("Success", "Profile Image updated successfully.", "success", 3000);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
        })

    }


    const updateCustomerProfileDetails = () => {
        let errorList = [];
        ValidateRecord(errorList);
        if (errorList.length < 1) {
            let method = "telispire/updateCustomerProfile";

            const formData = new FormData();
            for (var key in state) {
                if (state[key] && key != "fileName"
                    && key != "formFile"
                    && key != "encUserID"
                    && key != "ccExpMonth"
                    && key != "ccExpYear"
                )
                    if (key == 'workPhone' || key == 'homePhone' || key == 'shipPhone' || key == 'billingPhone') {
                        formData.append(key, state[key] ? state[key].replace(' ', '').replace('(', '').replace(')', '').replace('-', '') : '');
                    }
                    else {
                        formData.append(key, state[key]);
                    }

            }
            formData.append("creditCardExpiration", state.ccExpMonth + '/' + state.ccExpYear);
            formData.append("customerId", userID);
            formData.append("AssociateId", associateId);
            formData.append("UserType", userType);
            formData.append("formFile", profileImage.fileToSend);
            formData.append("fileName", profileImage.fileName);
            setIsLoading(true);

            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success == true) {
                    setErrorMessages([]);
                    showMessage("Success", "Record updated successfully.", "success", 3000);
                    setCustomerRecord(prevState => ({
                        ...prevState,
                        fullName: state.firstName,
                        email: state.email,
                        homeAddress1: state.homeAddress1,
                        homeAddress2: state.homeAddress2
                    }));
                    //getCustomerProfileDetails();
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }

    }

    const getUserProfileDetails = () => {
        var obj = { userId: userID, userType: userType };
        setIsLoading(true);
        PostDataAPI("user/getUserDetails", obj, true).then((result) => {
            if (result.success && result.data != null) {

                result.data.fullName = result.data.firstName
                result.data.email = result.data.emailAddress
                result.data.homeAddress1 = result.data.address1
                result.data.homeAddress2 = result.data.address2
                result.data.workPhone = formateMdnNumber(result.data.phoneNumber);
                result.data.confirmPassword = result.data.password;
                setCustomerRecord(result.data)
                setState(result.data);
                console.log(result.data)
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    const getCustomerProfileDetails = () => {
        var obj = { AccountNumber: accountNumber, customerID: userID, AssociateId: associateId };
        console.log(user_info);
        setIsLoading(true);
        PostDataAPI("telispire/getCustomerProfileDetail", obj, true).then((result) => {
            if (result.success && result.data != null) {
                result.data.objCustomerInfo.workPhone = formateMdnNumber(result.data.objCustomerInfo.workPhone);
                result.data.objCustomerInfo.homePhone = formateMdnNumber(result.data.objCustomerInfo.homePhone);
                result.data.objCustomerInfo.shipPhone = formateMdnNumber(result.data.objCustomerInfo.shipPhone);
                result.data.objCustomerInfo.billingPhone = formateMdnNumber(result.data.objCustomerInfo.billingPhone);
                result.data.objCustomerInfo.userPhotoPath = result.data.objCustomerInfo.photoPath;
                result.data.objCustomerInfo.emailAddress = result.data.objCustomerInfo.email;
                result.data.objCustomerInfo.confirmPassword = result.data.objCustomerInfo.password;
                debugger
                console.log(result.data.objCustomerInfo);
                setCustomerRecord(result.data.objCustomerInfo);
                if (result.data.objCustomerInfo.creditCardExpiration) {
                    var expiryDate = result.data.objCustomerInfo.creditCardExpiration.split('/');
                    result.data.objCustomerInfo.ccExpMonth = expiryDate[0];
                    result.data.objCustomerInfo.cc = expiryDate[1];
                }
                setState(result.data.objCustomerInfo);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    useEffect(() => {
        if (userType === 'customer_user') {
            getCustomerProfileDetails();
        } else {
            getUserProfileDetails();
        }

    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Profile </Typography>
            </div>
            <Grid container className={classes.boxContainer}>
                <Grid item lg={3} md={12} sm={12} xs={12}>
                    <div className={classes.whiteBox}>
                        <div className={classes.ProfileDetails}>
                            <div className={classes.profileImg}>

                                {profileImage.file || state.userPhotoPath ?
                                    <>

                                        <img src={profileImage.file ? profileImage.file : '.' + state.userPhotoPath} className='profile-image' />
                                    </>
                                    : <div className="user-profile-page" style={{ backgroundImage: 'URL(' + profilePlaceholder + ')' }}></div>
                                }
                                {/*<div className="user-profile-page" style={{ backgroundImage: 'URL(' + profilePlaceholder + ')' }}></div>*/}
                                <img className={classes.EditICon} src={EditPen} onClick={uploadFile} />
                                <form>
                                    <div>
                                        <input type="file" id="fileUploadField" ref={inputFile} className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                    </div>
                                </form>
                            </div>

                            <h3>{customerRecord?.fullName}</h3>
                            <p style={{ display: 'flex', alignItems: 'inherit' }}><img src={Envelope} /> {customerRecord?.email} </p>

                            {userType === 'customer_user' && (
                                <p style={{ display: 'flex', alignItems: 'inherit' }}>
                                    <img src={Location} alt="Location Icon" />
                                    {customerRecord?.homeAddress1 ? customerRecord?.homeAddress1 + (customerRecord?.homeAddress2 ? ", " + customerRecord?.homeAddress2 : "") : ""}
                                </p>
                            )}

                        </div>

                    </div>
                </Grid>
                <Grid item lg={9} md={12} sm={12} xs={12}>
                    <div className={classes.whiteBox}>
                        <h3> User Information </h3>

                        <Grid container spacing={2} className={classes.formContaner}>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <Label item title={userType == 'customer_user' ? 'Full Name' : 'First Name'} size={12} mandatory={true} />
                                <Grid item lg={12} md={12} sm={12}>
                                    <InputBaseField
                                        name="fullName"
                                        type="text"
                                        placeholder="Name"
                                        MaxLength="50"
                                        value={state?.fullName}
                                        onChange={handleChange}
                                    />
                                    {errorMessages.errorFullName && !state.fullName ? (
                                        <FormHelperText style={{ color: "red" }}>
                                            {userType === 'customer_user' ? 'Please enter full name' : 'Please enter first name'}
                                        </FormHelperText>
                                    ) : ('')}
                                </Grid>
                            </Grid>

                            {userType != 'customer_user' ?

                                <Grid item lg={6} md={6} sm={12} xs={12}>

                                    <Label item title="Last Name" size={12} mandatory={userType != 'customer_user' ? true : false} />
                                    <Grid lg={12} md={12} sm={12}>
                                        <InputBaseField
                                            name="lastName"
                                            type="text"
                                            placeholder="Last Name"
                                            value={state?.lastName}
                                            MaxLength="50"
                                            onChange={handleChange}
                                        />
                                        {errorMessages.errorlastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter last name
                                        </FormHelperText>) : ('')}


                                    </Grid>

                                </Grid> : ''}
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <Label item title="Email" size={12} mandatory={true} />
                                <Grid item lg={12} md={12} sm={12}>
                                    <InputBaseField
                                        name="emailAddress"
                                        placeholder="Email Address"
                                        MaxLength={14}
                                        type="text"
                                        value={state.emailAddress}
                                        IsDisabled={true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <Label item title="Phone" size={12} mandatory={true} />
                                <Grid item lg={12} md={12} sm={12}>
                                    <InputBaseField
                                        name="workPhone"
                                        placeholder="Phone Number"
                                        MaxLength={14}
                                        type="text"
                                        value={state.workPhone}
                                        onChange={handlePhoneChange}
                                    />
                                    {errorMessages.errorWorkPhone && (!state.workPhone || !validatePhoneNumber(state.workPhone)) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid phone number
                                    </FormHelperText>) : ('')}
                                </Grid>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <Label item title="Password" size={12} mandatory={true} />
                                <Grid item lg={12} md={12} sm={12}>
                                    <InputBaseField
                                        name="password"
                                        type="password"
                                        placeholder="Password"
                                        MaxLength="100"
                                        value={state?.password}
                                        onChange={handleChange}
                                        enablePasswordToggle={true}
                                    />
                                    {errorMessages.errorPassword && !state.password && (
                                        <FormHelperText style={{ color: "red" }}>
                                            Please enter a password
                                        </FormHelperText>
                                    )}
                                    {errorMessages.errorPasswordLength && state.password.length < 8 && (
                                        <FormHelperText style={{ color: "red" }}>
                                            Please enter at least 8 characters
                                        </FormHelperText>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>

                                <Label item title="Confirm Password" size={12} mandatory={true} />
                                <Grid item lg={12} md={12} sm={12}>
                                    <InputBaseField
                                        name="confirmPassword"
                                        type="password"
                                        placeholder="Confirm Password"
                                        MaxLength="100"
                                        value={state?.confirmPassword}
                                        onChange={handleChange}
                                        enablePasswordToggle={true}

                                    />
                                    {errorMessages.errorConfirmPassword && (state.password != state.confirmPassword) ? (<FormHelperText style={{ color: "red" }} >
                                        Password does not match
                                    </FormHelperText>) : ('')}
                                </Grid>
                            </Grid>
                        </Grid>




                        {userType === 'customer_user' ? <>
                            <h3> Home Address Information </h3>

                            <Grid container className={classes.formContaner}>

                                <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">
                                    <Grid row >
                                        <Label item title="Name" size={12} mandatory={true} />
                                        <InputBaseField
                                            name="homeContactName"
                                            type="text"
                                            placeholder="Name"
                                            MaxLength={50}
                                            value={state?.homeContactName}
                                            onChange={handleChange}
                                        />

                                        {errorMessages.errorHomeName && !state.homeContactName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter name
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                    <Grid row>
                                        <Label item title="Address Line 1" size={12} mandatory={true} />
                                        <InputBaseField
                                            name="homeAddress1"
                                            type="text"
                                            placeholder="Address Line 1"
                                            MaxLength={70}
                                            value={state?.homeAddress1}
                                            onChange={handleChange}
                                        />
                                        {errorMessages.errorHomeAddress1 && !state.homeAddress1 ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter address line 1
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                    <Grid row className="d-flex">
                                        <Grid item lg={6} md={6} sm={6} className="p-right-ten">
                                            <Label item title="City" size={12} mandatory={true} />
                                            <InputBaseField
                                                name="homeCity"
                                                type="email"
                                                placeholder="City"
                                                MaxLength={50}
                                                onChange={handleChange}
                                                value={state?.homeCity}
                                            />
                                            {errorMessages.errorHomeCity && !state.homeCity ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter city
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                        <Grid litem g={6} md={6} sm={6}>
                                            <Label item title="State" size={12} mandatory={true} />
                                            <Select
                                                size="small"
                                                native
                                                name="homeState"
                                                value={state?.homeState}
                                                onChange={handleSelectChange}
                                                placeholder="Select"
                                                label="Select"
                                                className={classes.selectBaseInput}
                                            >
                                                {lstStates.map(option =>
                                                    <option value={option.value}>{option.label}</option>
                                                )
                                                }
                                            </Select>
                                            {/*</Select>*/}
                                            {/*<SelectField*/}
                                            {/*    options={lstStates}*/}
                                            {/*    name= "homeState"*/}
                                            {/*    placeholder="Choose status"*/}
                                            {/*    value={state?.homeState}*/}
                                            {/*    onChange={handleSelectChange}*/}
                                            {/*></SelectField>*/}
                                            {errorMessages.errorHomeState && !state.homeState ? (<FormHelperText style={{ color: "red" }} >
                                                Please select state
                                            </FormHelperText>) : ('')}

                                        </Grid>

                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} sm={12} xs={12} >


                                    <Grid row>
                                        <Label item title="Phone" size={12} mandatory={true} />
                                        <InputBaseField
                                            name="homePhone"
                                            type="text"
                                            placeholder="Phone Number"
                                            MaxLength={14}
                                            onChange={handlePhoneChange}
                                            value={state?.homePhone}
                                        />
                                        {errorMessages.errorHomePhone && (!state.homePhone || !validatePhoneNumber(state.homePhone)) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid phone number
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                    <Grid row>
                                        <Label item title="Address Line 2" size={12} />
                                        <InputBaseField
                                            name="homeAddress2"
                                            type="text"
                                            placeholder="Address Line 2"
                                            MaxLength={70}
                                            onChange={handleChange}
                                            value={state?.homeAddress2}
                                        />
                                        {/*{errorMessages.errorHomeAddress2 && !state.homeAddress2 ? (<FormHelperText style={{ color: "red" }} >*/}
                                        {/*    Please enter home address 2*/}
                                        {/*</FormHelperText>) : ('')}*/}
                                    </Grid>

                                    <Grid row>
                                        <Label item title="Zip / Postal Code" size={12} mandatory={true} />
                                        <InputBaseField
                                            name="homeZip"
                                            type="text"
                                            placeholder="Zip / Postal Code"
                                            MaxLength={10}
                                            value={state?.homeZip}
                                            onChange={handleChange}
                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                        />
                                        {errorMessages.errorHomeZip && !state.homeZip ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter zip / postal code
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                </Grid>
                            </Grid></> : ''}

                        {/*<Grid container className={classes.formContaner}>*/}

                        {/*    <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">*/}
                        {/*        <Grid row >*/}
                        {/*            <Label item title="Name" size={12} mandatory={true} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="homeContactName"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Name"*/}
                        {/*                MaxLength={50}*/}
                        {/*                value={state?.homeContactName}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}

                        {/*            {errorMessages.errorHomeName && !state.homeContactName ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter name*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 1" size={12} mandatory={true} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="homeAddress1"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 1"*/}
                        {/*                MaxLength={200}*/}
                        {/*                value={state?.homeAddress1}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorHomeAddress1 && !state.homeAddress1 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter address1*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row className="d-flex">*/}
                        {/*            <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*                <Label item title="City" size={12} mandatory={true} />*/}
                        {/*                <InputBaseField*/}
                        {/*                    name="homeCity"*/}
                        {/*                    type="email"*/}
                        {/*                    placeholder="City"*/}
                        {/*                    MaxLength={50}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                    value={state?.homeCity}*/}
                        {/*                />*/}
                        {/*                {errorMessages.errorHomeCity && !state.homeCity ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please enter city*/}
                        {/*                </FormHelperText>) : ('')}*/}
                        {/*            </Grid>*/}
                        {/*            <Grid litem g={6} md={6} sm={6}>*/}
                        {/*                <Label item title="State" size={12} mandatory={true} />*/}
                        {/*                <Select*/}
                        {/*                    size="small"*/}
                        {/*                    native*/}
                        {/*                    name="homeState"*/}
                        {/*                    value={state?.homeState}*/}
                        {/*                    onChange={handleSelectChange}*/}
                        {/*                    placeholder="Select"*/}
                        {/*                    label="Select"*/}
                        {/*                    className={classes.selectBaseInput}*/}
                        {/*                >*/}
                        {/*                    {lstStates.map(option =>*/}
                        {/*                        <option value={option.value}>{option.label}</option>*/}
                        {/*                    )*/}
                        {/*                    }*/}
                        {/*                </Select>*/}
                        {/*                */}{/*</Select>*/}
                        {/*                */}{/*<SelectField*/}
                        {/*                */}{/*    options={lstStates}*/}
                        {/*                */}{/*    name= "homeState"*/}
                        {/*                */}{/*    placeholder="Choose status"*/}
                        {/*                */}{/*    value={state?.homeState}*/}
                        {/*                */}{/*    onChange={handleSelectChange}*/}
                        {/*                */}{/*></SelectField>*/}
                        {/*                {errorMessages.errorHomeState && !state.homeState ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please select home state*/}
                        {/*                </FormHelperText>) : ('')}*/}

                        {/*            </Grid>*/}

                        {/*        </Grid>*/}

                        {/*    </Grid>*/}

                        {/*    <Grid lg={6} md={6}  sm={12} xs={12} >*/}


                        {/*        <Grid row>*/}
                        {/*            <Label item title="Phone" size={12} mandatory={true} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="homePhone"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Phone"*/}
                        {/*                MaxLength={14}*/}
                        {/*                onChange={handlePhoneChange}*/}
                        {/*                value={state?.homePhone}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorHomePhone && (!state.homePhone || !validatePhoneNumber(state.homePhone)) ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid home phone number*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 2" size={12} mandatory={true} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="homeAddress2"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 2"*/}
                        {/*                MaxLength={200}*/}
                        {/*                onChange={handleChange}*/}
                        {/*                value={state?.homeAddress2}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorHomeAddress1 && !state.homeAddress1 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter home address1*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Zip" size={12} mandatory={true} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="homeZip"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="zip code"*/}
                        {/*                MaxLength={10}*/}
                        {/*                value={state?.homeZip}*/}
                        {/*                onChange={handleChange}*/}
                        {/*                onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorHomeZip && !state.homeZip ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter home zip*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*    </Grid>*/}
                        {/*</Grid>*/}


                        {/*<h3> Shipping Information </h3>*/}

                        {/*<Grid container className={classes.formContaner}>*/}

                        {/*    <Grid lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*        <Grid row >*/}
                        {/*            <Label item title="Name" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="shipName"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Name"*/}
                        {/*                MaxLength={50}*/}
                        {/*                value={state?.shipName}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorShipName && !state.shipName ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter ship address name*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 1" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="shipAddress1"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 1"*/}
                        {/*                MaxLength={200}*/}
                        {/*                value={state?.shipAddress1}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorShipAddress1 && !state.shipAddress1 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter ship address1*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row className="d-flex">*/}
                        {/*            <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*                <Label item title="City" size={12} />*/}
                        {/*                <InputBaseField*/}
                        {/*                    name="shipCity"*/}
                        {/*                    type="email"*/}
                        {/*                    placeholder="City"*/}
                        {/*                    MaxLength={50}*/}
                        {/*                    value={state?.shipCity}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                />*/}
                        {/*                {errorMessages.errorShipCity && !state.shipCity ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please enter ship address city*/}
                        {/*                </FormHelperText>) : ('')}*/}
                        {/*            </Grid>*/}
                        {/*            <Grid litem g={6} md={6} sm={6}>*/}
                        {/*                <Label item title="State" size={12} />*/}

                        {/*                <Select*/}
                        {/*                    size="small"*/}
                        {/*                    native*/}
                        {/*                    name="shipState"*/}
                        {/*                    value={state?.shipState}*/}
                        {/*                    onChange={handleSelectChange}*/}
                        {/*                    placeholder="Select"*/}
                        {/*                    label="Select"*/}
                        {/*                    className={classes.selectBaseInput}*/}
                        {/*                >*/}
                        {/*                    {lstStates.map(option =>*/}
                        {/*                        <option value={option.value}>{option.label}</option>*/}
                        {/*                    )*/}
                        {/*                    }*/}
                        {/*                </Select>*/}

                        {/*                */}{/*<SelectField*/}
                        {/*                */}{/*    name= "shipState"*/}
                        {/*                */}{/*    options={lstStates} placeholder="Choose state"*/}
                        {/*                */}{/*    value={state?.shipState}*/}
                        {/*                */}{/*    onChange={handleSelectChange}*/}
                        {/*                */}{/*></SelectField>*/}

                        {/*                {errorMessages.errorShipState && !state.shipState ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please enter ship address state*/}
                        {/*                </FormHelperText>) : ('')}*/}

                        {/*            </Grid>*/}

                        {/*        </Grid>*/}

                        {/*    </Grid>*/}

                        {/*    <Grid lg={6} md={6} sm={6}>*/}


                        {/*        <Grid row>*/}
                        {/*            <Label item title="Phone" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="shipPhone"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Phone"*/}
                        {/*                MaxLength={14}*/}
                        {/*                value={state?.shipPhone}*/}
                        {/*                onChange={handlePhoneChange}*/}
                        {/*            />*/}

                        {/*            {errorMessages.errorShipPhone && (!state.shipPhone || !validatePhoneNumber(state.shipPhone)) ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid ship phone number*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 2" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="shipAddress2"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 2"*/}
                        {/*                MaxLength={200}*/}
                        {/*                value={state?.shipAddress2}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.shipAddress2 && !state.shipAddress2 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter ship address2*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Zip" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="shipZip"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="zip code"*/}
                        {/*                MaxLength={10}*/}
                        {/*                value={state?.shipZip}*/}
                        {/*                onChange={handleChange}*/}
                        {/*                onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*            />*/}
                        {/*            {errorMessages.shipZip && !state.shipZip ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter ship address zip code*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*    </Grid>*/}





                        {/*</Grid>*/}

                        {/*<h3> Billing Information </h3>*/}

                        {/*<Grid container className={classes.formContaner}>*/}

                        {/*    <Grid lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*        <Grid row >*/}
                        {/*            <Label item title="Name" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="billingName"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Name"*/}
                        {/*                MaxLength={50}*/}
                        {/*                value={state?.billingName}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorBillingName && !state.billingName ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter billing address name*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 1" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="billingAddress1"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 1"*/}
                        {/*                MaxLength={200}*/}
                        {/*                value={state?.billingAddress1}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorBillingAddress1 && !state.billingAddress1 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter billing address1*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row className="d-flex">*/}
                        {/*            <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*                <Label item title="City" size={12} />*/}
                        {/*                <InputBaseField*/}
                        {/*                    name="billingCity"*/}
                        {/*                    type="email"*/}
                        {/*                    placeholder="City"*/}
                        {/*                    MaxLength={50}*/}
                        {/*                    value={state?.billingCity}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                />*/}
                        {/*                {errorMessages.errorBillingCity && !state.billingCity ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please enter billing address city*/}
                        {/*                </FormHelperText>) : ('')}*/}
                        {/*            </Grid>*/}
                        {/*            <Grid litem g={6} md={6} sm={6}>*/}
                        {/*                <Label item title="State" size={12} />*/}
                        {/*                <Select*/}
                        {/*                    size="small"*/}
                        {/*                    native*/}
                        {/*                    name="billingState"*/}
                        {/*                    value={state?.billingState}*/}
                        {/*                    onChange={handleSelectChange}*/}
                        {/*                    placeholder="Select"*/}
                        {/*                    label="Select"*/}
                        {/*                    className={classes.selectBaseInput}*/}
                        {/*                >*/}
                        {/*                    {lstStates.map(option =>*/}
                        {/*                        <option value={option.value}>{option.label}</option>*/}
                        {/*                    )*/}
                        {/*                    }*/}
                        {/*                </Select>*/}

                        {/*                */}{/*<SelectField*/}
                        {/*                */}{/*    name="billingState"*/}
                        {/*                */}{/*    options={lstStates}*/}
                        {/*                */}{/*    placeholder="Choose status"*/}
                        {/*                */}{/*    value={state.billingState}*/}
                        {/*                */}{/*    onChange={handleSelectChange}*/}
                        {/*                */}{/*></SelectField>*/}
                        {/*                {errorMessages.errorBillingState && !state.billingState ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please select billing address state*/}
                        {/*                </FormHelperText>) : ('')}*/}

                        {/*            </Grid>*/}

                        {/*        </Grid>*/}

                        {/*    </Grid>*/}

                        {/*    <Grid lg={6} md={6} sm={6}>*/}


                        {/*        <Grid row>*/}
                        {/*            <Label item title="Phone" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="billingPhone"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Phone"*/}
                        {/*                MaxLength={14}*/}
                        {/*                value={state?.billingPhone}*/}
                        {/*                onChange={handlePhoneChange}*/}
                        {/*                onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorBillingPhone && (!state.billingPhone || !validatePhoneNumber(state.billingPhone)) ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid billing phone number*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Address Line 2" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="billingAddress2"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Address Line 2"*/}
                        {/*                MaxLength={200}*/}
                        {/*                value={state?.billingAddress2}*/}
                        {/*                onChange={handleChange}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorBillingAddress1 && !state.billingAddress2 ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid billing address 1*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*        <Grid row>*/}
                        {/*            <Label item title="Zip" size={12} />*/}
                        {/*            <InputBaseField*/}
                        {/*                name="billingZip"*/}
                        {/*                type="text"*/}
                        {/*                placeholder="Zip"*/}
                        {/*                onChange={handleChange}*/}
                        {/*                MaxLength={10}*/}
                        {/*                value={state?.billingZip}*/}
                        {/*                onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*            />*/}
                        {/*            {errorMessages.errorBillingZip && !state.billingZip ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid billing zip*/}
                        {/*            </FormHelperText>) : ('')}*/}
                        {/*        </Grid>*/}

                        {/*    </Grid>*/}

                        {/*</Grid>*/}

                        {/*<Grid container className={classes.formContaner}>*/}
                        {/*    <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*        <Grid row className="d-flex">*/}
                        {/*            <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*                <Label item title="Card Type" size={12} />*/}

                        {/*                <Select*/}
                        {/*                    size="small"*/}
                        {/*                    native*/}
                        {/*                    name="creditCardType"*/}
                        {/*                    value={state?.creditCardType}*/}
                        {/*                    onChange={handleSelectChange}*/}
                        {/*                    placeholder="Select"*/}
                        {/*                    label="Select"*/}
                        {/*                    className={classes.selectBaseInput}*/}
                        {/*                >*/}
                        {/*                    {lstCCType.map(option =>*/}
                        {/*                        <option value={option.value}>{option.label}</option>*/}
                        {/*                    )*/}
                        {/*                    }*/}
                        {/*                </Select>*/}
                        {/*                */}{/*<SelectField*/}
                        {/*                */}{/*    name="creditCardType"*/}
                        {/*                */}{/*    onChange={handleSelectChange}*/}
                        {/*                */}{/*    options={lstCCType}></SelectField>*/}
                        {/*                {errorMessages.errorCardType && !state.creditCardType ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please select credit card type*/}
                        {/*                </FormHelperText>) : ('')}*/}
                        {/*            </Grid>*/}
                        {/*            <Grid litem g={6} md={6} sm={6}>*/}
                        {/*                <Label item title="Card" size={12} />*/}

                        {/*                <InputBaseField*/}
                        {/*                    name="creditCardNumber"*/}
                        {/*                    onChange={handleCardChange}*/}
                        {/*                    placeholder="Credit Card Number"*/}
                        {/*                    type="text"*/}
                        {/*                    MaxLength={19}*/}
                        {/*                    value={state?.creditCardNumber}*/}
                        {/*                />*/}

                        {/*                {errorMessages.errorCardNumber && !state.creditCardNumber ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                    Please enter valid credit card number*/}
                        {/*                </FormHelperText>) : ('')}*/}

                        {/*            </Grid>*/}

                        {/*        </Grid>*/}
                        {/*    </Grid>*/}

                        {/*    <Grid item lg={6} md={6} sm={6}>*/}
                        {/*        <Grid row className="d-flex">*/}
                        {/*            <Grid item lg={6} md={6} sm={6} className="p-right-ten">*/}
                        {/*                <Label item title="Expiry" size={12} />*/}
                        {/*                <InputBaseField*/}
                        {/*                    name="ccExpMonth"*/}
                        {/*                    value={state?.ccExpMonth}*/}
                        {/*                    type="text"*/}
                        {/*                    placeholder="Month"*/}
                        {/*                    MaxLength={2}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                    onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*                />*/}
                        {/*            </Grid>*/}
                        {/*            <Grid litem g={6} md={6} sm={6}>*/}
                        {/*                <Label item title="" size={12} />*/}
                        {/*                <InputBaseField*/}
                        {/*                    name="ccExpYear"*/}
                        {/*                    value={state?.ccExpYear}*/}
                        {/*                    type="text"*/}
                        {/*                    placeholder="Year"*/}
                        {/*                    MaxLength={2}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                    onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                        {/*                />*/}

                        {/*            </Grid>*/}
                        {/*            {errorMessages.errorCardExpiration && !validateCreditCardExpiry() ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*                Please enter valid credit card expiration*/}
                        {/*            </FormHelperText>) : ('')}*/}

                        {/*        </Grid>*/}

                        {/*    </Grid>*/}

                        {/*</Grid>*/}

                        <Grid container className={classes.formContaner}>
                            <div className={classes.footer}>
                                <div className={classes.footerRight}>
                                    <Button className={classes.changeBtn} onClick={() => { updateCustomerProfileDetails() }}>Save</Button>
                                </div>
                            </div>
                        </Grid>


                    </div>
                </Grid >
            </Grid >

        </>
    )
}

export default withSnackbar(Profile);